import React, { Component } from "react";
import SingleSelect from '../components/common/SingleSelect';
import './style.scss';

export default class Dropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { label, selectedValue, dropdownOptions, errors, onDropdownChange, disabled, id } = this.props;
        return (
            <>
                <div className="p-10" id={id}>
                    <label htmlFor="title" className="form-labels">
                        {label}
                    </label>
                    <SingleSelect
                        selectedValue={selectedValue}
                        disabled={disabled}
                        dropdownOptions={dropdownOptions}
                        onDropdownChange={onDropdownChange} />
                </div>
                {errors && <div className="field-error">{errors}</div>}
            </>
        )
    }
}

